/* src/app/shared/components/modals/group-modal/group-modal.component.scss */
.modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 600;
}
.modal-title .title-icon {
  font-size: 1.2rem;
}
.modal-form {
  padding: 1.5rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.field-label {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  opacity: 0.8;
  padding-left: 4px;
}
.field-label.required::after {
  content: " *";
  color: var(--ion-color-danger);
}
.field-item {
  margin-top: 2px;
}
.field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 4px;
  color: var(--ion-color-warning);
  font-size: 1rem;
}
.field-error ion-icon {
  font-size: 1.5rem;
}
.toggle-item {
  --background: rgba(var(--ion-color-secondary-contrast-rgb), 0.06);
  --border-radius: 8px;
  --padding-start: 12px;
  border-radius: 8px;
}
.toggle-item .toggle-icon {
  font-size: 2rem;
  color: var(--ion-color-secondary-contrast);
}
.toggle-item ion-label {
  color: var(--ion-color-secondary-contrast) !important;
}
.toggle-item ion-toggle {
  --track-background-checked: var(--ion-color-medium);
  --handle-background: var(--ion-color-secondary-contrast);
  --handle-background-checked: var(--ion-color-secondary-contrast);
}
.collapsable-section .field-item {
  --min-height: 52px;
}
.collapsable-section .empty-label {
  font-size: 0.85rem;
  font-style: italic;
  opacity: 0.6;
}
.collapsable-section .add-btn {
  height: 32px;
}
/*# sourceMappingURL=group-modal.component-GPRMCTAT.css.map */
